import elements from "./elements.json";
import main from "./main.json";
import properties from "./properties.json";

export default { elements, ...main, properties };
